function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { asMultiStyleConfig } from '../../utils/theme';
import { get } from '../../utils';
import { getColor } from '../../theme-tools';
var parts = ['button', 'leftIcon', 'rightIcon', 'spinner'];
var iconSharedStyles = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)'
};
var variantTertiaryIconSharedStyles = {
  position: 'unset',
  transform: 'unset',
  top: 'unset'
};
var variantTertiaryRightIconSharedStyles = {
  right: 'unset',
  ml: 2
};
export var variantPrimary = props => {
  var {
    theme
  } = props;
  return {
    button: {
      bg: 'blue.600',
      color: 'white',
      _focus: {
        bg: 'blue.700',
        borderColor: 'white',
        borderWidth: '0.125rem',
        boxShadow: "\n         0 0 0.125rem 0.125rem ".concat(getColor(theme, 'blue.200'), ",\n         0 0 0.125rem 0.125rem ").concat(getColor(theme, 'blue.300')),
        color: 'white',
        outline: 'none'
      },
      _hover: {
        bg: 'blue.550',
        color: 'white',
        outline: 'none'
      },
      _active: {
        bg: 'blue.700',
        color: 'white',
        outline: 'none'
      },
      _disabled: {
        bg: 'grey.800',
        borderColor: 'grey.800',
        color: 'white',
        _hover: {
          bg: 'grey.800'
        }
      }
    }
  };
};
export var variantSecondary = props => {
  var {
    theme
  } = props;
  return {
    button: {
      bg: 'white',
      borderColor: 'blue.600',
      color: 'blue.600',
      _focus: {
        bg: 'white',
        borderColor: 'blue.600',
        borderWidth: '0.063rem',
        boxShadow: "\n         0 0 0.125rem 0.125rem ".concat(getColor(theme, 'blue.200'), ",\n         0 0 0.125rem 0.125rem ").concat(getColor(theme, 'blue.300')),
        outline: 'none'
      },
      _hover: {
        bg: 'blue.1140',
        borderColor: 'blue.600'
      },
      _active: {
        bg: 'blue.1150',
        borderColor: 'blue.600'
      },
      _disabled: {
        bg: 'white',
        borderColor: 'grey.500',
        color: 'grey.800'
      }
    }
  };
};
export var variantTertiary = props => {
  var {
    theme
  } = props;
  return {
    button: {
      bg: 'white',
      borderColor: 'transparent',
      color: 'blue.600',
      _focus: {
        bg: 'white',
        boxShadow: "\n        0 0 0.125rem 0.125rem ".concat(getColor(theme, 'blue.200'), ",\n        0 0 0.125rem 0.125rem ").concat(getColor(theme, 'blue.300')),
        outline: 'none',
        color: 'blue.600'
      },
      _hover: {
        bg: 'blue.1140',
        borderColor: 'transparent'
      },
      _active: {
        bg: 'blue.1150',
        borderColor: 'transparent'
      },
      _disabled: {
        bg: 'white',
        color: 'grey.800'
      }
    },
    leftIcon: _objectSpread(_objectSpread({}, variantTertiaryIconSharedStyles), {}, {
      left: 'unset',
      mr: 2
    }),
    rightIcon: _objectSpread(_objectSpread({}, variantTertiaryIconSharedStyles), variantTertiaryRightIconSharedStyles),
    spinner: _objectSpread(_objectSpread({}, variantTertiaryIconSharedStyles), variantTertiaryRightIconSharedStyles)
  };
};
export var variantDanger = props => {
  var {
    theme
  } = props;
  return {
    button: {
      bg: 'red.700',
      color: 'white',
      _focus: {
        bg: 'red.700',
        borderColor: 'white',
        borderWidth: '0.125rem',
        boxShadow: "\n        0 0 0.125rem 0.125rem ".concat(getColor(theme, 'red.1000'), ",\n        0 0 0.125rem 0.125rem ").concat(getColor(theme, 'red.1000')),
        color: 'white',
        outline: 'none'
      },
      _hover: {
        bg: 'red.1000',
        color: 'white',
        outline: 'none'
      },
      _active: {
        bg: 'blue.900',
        color: 'white',
        outline: 'none'
      },
      _disabled: {
        bg: 'grey.900',
        borderColor: 'grey.900',
        color: 'white',
        _hover: {
          bg: 'grey.900'
        }
      }
    }
  };
};
var baseStyle = {
  button: {
    border: '1px',
    position: 'relative',
    lineHeight: '1.2',
    fontWeight: 'semibold',
    borderRadius: '1.56rem',
    bg: 'red.600',
    _focus: {
      boxShadow: 'outline'
    },
    _disabled: {
      bg: 'neutral.1',
      cursor: 'not-allowed',
      boxShadow: 'none'
    }
  },
  spinner: _objectSpread({}, iconSharedStyles),
  leftIcon: _objectSpread({}, iconSharedStyles),
  rightIcon: _objectSpread({}, iconSharedStyles)
};
var variantUnstyled = {
  button: {
    bg: 'none',
    color: 'inherit',
    display: 'inline',
    lineHeight: 'inherit',
    m: 0,
    p: 0
  }
};
export var buttonSizes = {
  md: props => {
    var {
      rightIcon,
      leftIcon,
      theme,
      isLoading
    } = props;
    var hasIcon = !!leftIcon || !!rightIcon || !!isLoading;
    var iconSpacing = get(theme, "space.".concat(props.iconSpacing), '1rem');
    return {
      button: {
        h: 11,
        minW: {
          base: '12rem',
          md: '15.5rem'
        },
        fontSize: 'md',
        px: hasIcon ? "calc(1rem + 1em + ".concat(iconSpacing, ")") : 4
      },
      spinner: {
        right: 4,
        fontSize: '1em',
        lineHeight: 'normal'
      },
      leftIcon: {
        left: 4
      },
      rightIcon: {
        right: 4
      }
    };
  },
  sm: props => {
    var {
      rightIcon,
      leftIcon,
      theme,
      isLoading
    } = props;
    var hasIcon = !!leftIcon || !!rightIcon || !!isLoading;
    var iconSpacing = get(theme, "space.1", '.25rem');
    return {
      button: {
        h: 8,
        minW: {
          md: 30
        },
        fontSize: 'sm',
        px: hasIcon ? "calc(1rem + 1em + ".concat(iconSpacing, ")") : 3
      },
      spinner: {
        right: 3,
        fontSize: '1em',
        lineHeight: 'normal'
      },
      leftIcon: {
        left: 3
      },
      rightIcon: {
        right: 3
      }
    };
  },
  xs: props => {
    var {
      rightIcon,
      leftIcon,
      theme,
      isLoading
    } = props;
    var hasIcon = !!leftIcon || !!rightIcon || !!isLoading;
    var iconSpacing = get(theme, "space.1", '.25rem');
    return {
      button: {
        h: 6,
        minW: {
          md: 21
        },
        fontSize: 'sm',
        px: hasIcon ? "calc(1rem + 1em + ".concat(iconSpacing, ")") : 3
      },
      spinner: {
        right: 2,
        fontSize: '1em',
        lineHeight: 'normal'
      },
      leftIcon: {
        fontSize: '.75rem',
        left: 2
      },
      rightIcon: {
        fontSize: '.75rem',
        right: 2
      }
    };
  }
};
var defaultProps = {
  variant: 'primary',
  size: 'md'
};
export default asMultiStyleConfig({
  parts,
  baseStyle,
  sizes: buttonSizes,
  defaultProps,
  variants: {
    primary: variantPrimary,
    secondary: variantSecondary,
    tertiary: variantTertiary,
    danger: variantDanger,
    unstyled: variantUnstyled
  },
  compoundModifiers: [{
    size: 'xs',
    variant: 'tertiary',
    style: {
      button: {
        px: 3
      }
    }
  }, {
    size: 'sm',
    variant: 'tertiary',
    style: {
      button: {
        px: 3
      }
    }
  }, {
    size: 'md',
    variant: 'tertiary',
    style: {
      button: {
        px: 4
      }
    }
  }]
});